module.exports = __webpack_public_path__ + "img/holiday-contacts.c2a06a31.png";